import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { SideDrawerContentContainer } from '../../../../../v2BaseComponents/SideDrawer';
import OrganizationUserDetails from '../../../../../shared/OrganizationUsers/OrganizationUserDetails';
import useOrganizationUsers from '../../../../../../hooks/api/useOrganizationUsers';

export type OrganizationUserDetailsDrawerContentOwnProps = {
    organizationUserId: string;
};

export type OrganizationUserDetailsDrawerContentProps = OrganizationUserDetailsDrawerContentOwnProps;

const OrganizationUserDetailsDrawerContent: React.FC<OrganizationUserDetailsDrawerContentProps> = ({
    organizationUserId,
}) => {
    const { isLoadingUser } = useOrganizationUsers({
        organizationUserId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingUser}>
            {() => (
                <SideDrawerContentContainer>
                    <OrganizationUserDetails organizationUserId={organizationUserId!} />
                </SideDrawerContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationUserDetailsDrawerContent);
